import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'profile',
  children: {
    profile: {
      path: '',
    },
    personal: {
      path: 'personal',
    },
    hiring: {
      path: 'hiring',
    },
    contractVersions: {
      path: 'contract_versions',
      children: {
        contractVersionId: {
          level: 2,
          path: ':contractVersionId',
        },
      },
    },
    competencies: {
      path: 'competencies',
    },
    planningVersions: {
      path: 'planning_versions',
      children: {
        planningVersionId: {
          path: ':planningVersionId',
        },
      },
    },
    customTables: {
      size: 'full',
      path: 'custom_tables',
      children: {
        schemaIdNew: {
          size: 'full',
          path: ':schemaId/new',
        },
        schemaIdValuesValueIdEdit: {
          size: 'full',
          path: ':schemaId/values/:valueId/edit',
        },
        schemaIdValuesValueIdDelete: {
          size: 'full',
          path: ':schemaId/values/:valueId/delete',
        },
      },
    },
    overview: {
      path: 'overview',
    },
    workDetails: {
      path: 'work-details',
    },
    performance: {
      path: 'performance',
    },
    talent: {
      path: 'talent',
    },
  },
} as const satisfies Location
